// @flow
import { useFormContext } from 'react-hook-form';

import { Text, Radio, RadioGroup, View } from 'reshaped';

import { useTranslator, mapTags } from '@gandi/translate';

type Props = {
  delegate: 'yes' | 'no',
  setDelegate: React.ReactSetStateFunction<'no' | 'yes'>,
};

export function DelegateRadio({
  delegate,
  setDelegate,
}: Props): React.MixedElement | null {
  const { __ } = useTranslator();

  const form = useFormContext();
  const email = form.watch('email');

  function onChange({ value }: { value: 'yes' | 'no' }) {
    setDelegate(value);
  }

  return (
    <View paddingBlock={4} gap={3}>
      <Text variant="body-2" weight="bold">
        {__('Are you working in this organization?')}
      </Text>

      {/* $FlowFixMe[incompatible-type] */}
      <RadioGroup name="delegate" onChange={onChange} value={delegate}>
        <View gap={2}>
          {/* $FlowFixMe[incompatible-type] */}
          <Radio value="no">
            <View.Item grow>
              <Text as="p" variant="body-3">
                {__('Yes, I am working there')}
              </Text>
            </View.Item>
          </Radio>
          <div>
            {/* $FlowFixMe[incompatible-type] */}
            <Radio value="yes">
              <View.Item grow>
                <Text as="p" variant="body-3">
                  {__('No, I am starting a project for them')}
                </Text>
              </View.Item>
            </Radio>
            <View paddingStart={7}>
              <Text as="p" variant="caption-1" color="neutral-faded">
                {mapTags(
                  __(
                    'You will have admin rights for the purchased products. [[email:The provided email address]] will have owner rights and receive an invitation to create an account.',
                  ),
                  ({ email: fallback }) => ({ email: email || fallback }),
                )}
              </Text>
            </View>
          </div>
        </View>
      </RadioGroup>
    </View>
  );
}
